import axios from "axios";
import { clearSessionStorage, resetNavigation } from "../Utils/Utils";
const isFullUrl = (url) => /^https?:\/\//i.test(url);

export const GET_API = async (path, headers = "", params) => {
  var config = {
    method: "get",
    url: window.baseUrl + path,
    headers: { Authorization: "Bearer " + headers },
  };
  var config = headers
    ? {
        method: "get",
        url: window.baseUrl + path,
        headers: { Authorization: "Bearer " + headers },
      }
    : { method: "get", url: window.baseUrl + path };

  let response = await axios(config)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      if (error.response) {
        return error.response;
      } else {
        return { status: 503, message: "NetWork Error !" };
      }
    });

  return ResponseValidation(response, config);
};
export const DELETE_API = async (path, headers = "", params) => {
  var config = headers
    ? {
        method: "delete",
        url: window.baseUrl + path,
        headers: { Authorization: "Bearer " + headers },
      }
    : { method: "delete", url: window.baseUrl + path };

  let response = await axios(config)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      if (error.response) {
        return error.response;
      } else {
        return { status: 503, message: "NetWork Error !" };
      }
    });

  return ResponseValidation(response, config);
};

export const POST_API = async (data, path, headers = "") => {
  const url = isFullUrl(path) ? path : window.baseUrl + path;
  var config = headers
    ? {
        method: "post",
        url: url,
        headers: {
          Authorization: "Bearer " + headers,
        },
        data: data,
      }
    : {
        method: "post",
        url: url,
        data: data,
      };

  let response = await axios(config)
    .then(function (response) {
      return response;
    })

    .catch(function (error) {
      if (error.response) {
        return error.response;
      } else {
        return { status: 503, message: "NetWork Error !", config };
      }
    });
  return ResponseValidation(response, config);
};
export const PUT_API = async (data, path, headers = "") => {
  var config = headers
    ? {
        method: "put",
        url: window.baseUrl + path,
        headers: {
          Authorization: "Bearer " + headers,
        },
        data: data,
      }
    : {
        method: "put",
        url: window.baseUrl + path,
        data: data,
      };

  let response = await axios(config)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      if (error.response) {
        return error.response;
      } else {
        return { status: 503, message: "Network Error !", config };
      }
    });
  return ResponseValidation(response, config);
};

let count404Request = 0;
export const ResponseValidation = async (response, config, navigations) => {
  let status_code = null;
  let response_data = null;
  let message = null;

  if (response) {
    if (response.status) {
      if (response.status === 200) {
        message = "Success";
        status_code = response.status;
        response_data = response.data;
      } else if ([401].includes(response.status)) {
        await clearSessionStorage();
        status_code = response.status;
        message = "Session Expired. Please log in again to continue";
        setTimeout(() => {
          resetNavigation("/");
        }, 3000);
      } else if (response.status === 400) {
        message = response.data.message;
        status_code = response.status;
        response_data = response.data;
      } else if (response.status === 404) {
        message = response.data.message || "Page Not found";
        status_code = response.status;
        response_data = 0;
      } else if (response.status === 406) {
        message = "No visible text in page";
        status_code = response.status;
        response_data = 0;
      } else if (response.status === 403) {
        message = response.data.message;
        status_code = response.status;
        response_data = 0;
      } else if (response.status === 500) {
        message = response.data.message;
        status_code = response.status;
        response_data = 0;
      } else if (response.status === 503) {
        status_code = response.status;
        response_data = 0;
        if (count404Request == 0) {
          message =
            "Network Error: Unable to connect to the server. Please try again later.";
        }
        setTimeout(() => {
          count404Request = 0;
        }, 150);

        count404Request++;
      } else if (response.status === 422) {
        message = response.data.message;
        status_code = response.status;
        response_data = response.data;
      } else {
        message = "Unhandled Condition met";
        response_data = 0;
      }
      return { response_data, message, status_code };
    } else {
      message = "unexpected response got";
      return { message, status_code };
    }
  }
};
